import CustomTextField from "components/CustomTextField";
import { Col, Row, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { useParams, useLocation } from "react-router-dom";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  useGetAllLiabilityOfUsersQuery,
  useCreateLiabilitiesDetailMutation,
  useUpdateLiabilitiesDetailMutation,
} from "./farmerApiSlice";
import { useEffect, useState } from "react";
import FarmerNoResponse from "./FarmerNoResponse";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { useGetInstitutesQuery } from "features/masterdata/MasterApiSlice";
import { LoaderDesign } from "./LoaderDesign";
import { Badge } from "antd";
import CardSkeleton from "components/CardSkeleton";
import { Divider } from "@mui/material";
const FarmerDetailsLiability = () => {
  const { id } = useParams();
  const location = useLocation();
  const fullname = location.state?.fullname || "";
  const [LiabilitiesList, setLiabilitiesList] = useState([]);
  const [showError, setError] = useState(false);
  const [createLiabilities] = useCreateLiabilitiesDetailMutation();
  const [updateLiabilities] = useUpdateLiabilitiesDetailMutation();
  const [disableButton, disableSubmitBtn] = useState(false);
  const [showLoader, setLoader] = useState(false);
  const { data: data, refetch, isLoading } = useGetAllLiabilityOfUsersQuery(id);
  const { data: Institute } = useGetInstitutesQuery();
  const [showAddModal, setshowAddModal] = useState(false);
  const [SubmitButtonApi, setSubmitButtonApi] = useState(false);
  const [updateId, setUpdateId] = useState("");

  const [Group, editGroup] = useState({
    purpose_of_loan: "",
    overdue: "",
    liability_type: "",
    current_outstanding: "",
    installment_amount: "",
    security_offered: "",
    institution: "",
    account_status: "",
  });
  const [InstituteList, setInstituteList] = useState([]);
  useEffect(() => {
    if (Institute) {
      setInstituteList(Institute?.data);
    }
  }, [Institute]);
  useEffect(() => {
    const userFromApi = data?.data ? data?.data : LiabilitiesList;
    if (userFromApi !== undefined) setLiabilitiesList(userFromApi);
  }, [data]);

  const AddModal = (updateButtonTag, list) => {
    if (updateButtonTag) {
      setSubmitButtonApi(true);
      setUpdateId(list.id);
    }

    let currentList = {
      purpose_of_loan: list.purpose_of_loan,
      overdue: list.overdue,
      liability_type: list.liability_type,
      current_outstanding: list.current_outstanding,
      installment_amount: list.installment_amount,
      security_offered: list.security_offered,
      institution: list.institution,
      account_status: list.account_status,
    };
    editGroup(currentList);
    setshowAddModal(true);
  };
  const handleClose = () => {
    setshowAddModal(false);
    setError(false);
    setSubmitButtonApi(false);
    setUpdateId("");
    editGroup({
      purpose_of_loan: "",
      overdue: "",
      liability_type: "",
      current_outstanding: "",
      installment_amount: "",
      security_offered: "",
      institution: "",
      account_status: "",
    });
    disableSubmitBtn(false);
  };
  const onInputChange = (event) => {
    editGroup({
      ...Group,
      [event.target.name]: event.target.value,
    });
  };
  const handleValidations = () => {
    var status = false;
    Object.entries(Group).forEach(([key, value]) => {
      if (value === "") {
        setError(true);
        status = true;
      }
    });
    return status;
  };
  const AddFamilytSubmit = async () => {
    var status;
    status = await handleValidations();
    if (!status) {
      disableSubmitBtn(true);
      if (!SubmitButtonApi) {
        createLiabilities({ id: id, payload: Group })
          .unwrap()
          .then((data) => {
            // toast.success("Liabilities Created")
            swal("Liability Created Successfully", {
              buttons: false,
              icon: "success",
              title: "Liability Created Detail",
              timer: 1500,
            });
            setshowAddModal(false);
            disableSubmitBtn(false);
            refetch();
          })
          .catch((error) => {
            toast.error("Error while Creating Member");
            return;
          });
      } else {
        updateLiabilities({ id: updateId, payload: Group })
          .unwrap()
          .then((data) => {
            toast.success("Liabilities Updated");
            setshowAddModal(false);
            swal("Liabilities Updated Successfully", {
              buttons: false,
              icon: "success",
              title: "Liabilities Updated Detail",
              timer: 1500,
            });
            disableSubmitBtn(false);
            refetch();
          })
          .catch((error) => {
            toast.error("Error while Updating Member");
            disableSubmitBtn(false);
            return;
          });
      }
    }
  };
  const ReloadApplication = () => {
    setLoader(true);
    setTimeout(() => {
      refetch();
      setLoader(false);
    }, 1500);
  };

  return (
       <Card className="globalboxshadow">
            <div
              className="d-flex justify-content-between  align-items-center "
              style={{ borderRadius: "5px",backgroundColor:"#f1f1f1" }}
            >
              <div className="heading-title mt-lg-0 mt-2 py-3">
                      <h5
                        className="mx-4"
                        style={{
                          fontSize: "18px",
                          color: "black",
                        }}
                      >
                        <i
                          className="mdi mdi-account-hard-hat me-2"
                          style={{ fontSize: "1.5rem" }}
                        ></i>
                        {fullname}
                      </h5>
                    </div>
              <div
                className="d-flex justify-content-end align-items-center flex-wrap"
                style={{ gap: "6px" }}
              >
                <Button
                  id="AddDetails99"
                  type=""
                  className="buttonOrangeDefaultColor"
                  onClick={() => AddModal(false, Group)}
                  size="sm"
                >
                  Add <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
                </Button>
                <Button
                  className="bg-transparent text-black fs-6 reloadButton me-2"
                  size="sm"
                  onClick={ReloadApplication}
                >
                 Reload <FontAwesomeIcon icon={faRotateLeft} />
                </Button>
                </div>
            </div>
      {isLoading ? (
        <div className="mt-4">
          <CardSkeleton />
        </div>
      ) : LiabilitiesList.length === 0 ? (
        <FarmerNoResponse  className=""/>
      ) : (
        <div className="transparent_card">
          <div className="">
            <div className="table-responsive d-lg-block d-md-block d-none">
          
            <div className="">
  {LiabilitiesList &&
    LiabilitiesList.map((fmd, index) => (
      <div className="d-lg-block d-md-none d-none  transparent_card custom_mb" key={index}>
                      <Divider style={{ borderTop: "2px dotted orange",marginBottom:"5px" }} />
        <div className="p-1 p-lg-3">
          <div className="row text-gray">
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="loan_purpose" value={fmd.purpose_of_loan || "N/A"} disabled />
            </div>
            <div className="col-md-4 mb-3">
              <CustomTextField type="text" name="institution" value={fmd.institution || "N/A"} disabled />
            </div>
            {/* <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="created_at" value={fmd.created_at || "N/A"} disabled />
            </div> */}
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="overdue" value={fmd.overdue || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="current_outstanding" value={fmd.current_outstanding || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="installment_amount" value={fmd.installment_amount || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="liability_type" value={fmd.liability_type || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="account_status" value={fmd.account_status || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="security_offered" value={fmd.security_offered || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="interest_rate" value={fmd.interest_rate || ""} disabled />
            </div>  
          </div>
          <div className="col-12 text-end p-2 mt-2 mb-0 d-lg-block d-md-none d-none">
                        <Button
                          id="editDetails"
                          type=""
                          className="buttonOrangeDefaultColor"
                          onClick={() => AddModal(true, fmd)}
                          size="sm"
                        >
                          Edit&nbsp; <FontAwesomeIcon icon={faPenToSquare} />
                        </Button>
                    </div>
        </div>
      </div>
    ))}
</div>
            </div>
            <Col>
              <div className="d-flex flex-lg-row flex-md-row flex-wrap  d-lg-none d-md-block d-block">
                {LiabilitiesList && LiabilitiesList.length > 0 ? (
                  LiabilitiesList.map((fmd, index) => (
                    <Card
                      className="transparent_card custom_mb w-100 mb-2"
                      key={index}
                      lg="10"
                      md="5"
                      xs="12"
                    >
                      <CardBody className="p-1 p-lg-3">
                        <div className="hover-shadow d-lg-none d-md-block d-block rounded-3 bg-white p-3">
                          <CardTitle className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <div>
                                <span
                                  className="font-weight-bold"
                                  style={{
                                    fontSize: "15px",
                                    color: "#333",
                                    marginLeft: "8px",
                                  }}
                                >
                                  Purpose of Loan:
                                  <span className="text-success mx-1">
                                    {fmd.purpose_of_loan || "N/A"}{" "}
                                  </span>
                                </span>
                              </div>
                              <div className="">
                                <FontAwesomeIcon
                                  onClick={() => AddModal(true, fmd)}
                                  className="mx-1"
                                  icon={faPenToSquare}
                                  style={{
                                    color: "orange",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            </div>
                          </CardTitle>
                          <hr
                            className="mt-0 mb-2"
                            style={{ borderColor: "#FF8C00" }}
                          />

                          <Table className="table mb-0">
                            <tbody>
                              <tr>
                                <th>Overdues:</th>

                                <td>
                                  {" "}
                                  <span>{fmd.overdue || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Current Outs.:</th>
                                <td>
                                  <span>
                                    {fmd.current_outstanding || "N/A"}
                                  </span>
                                </td>
                              </tr>

                              <tr>
                                <th>Installment Amt.:</th>
                                <td>
                                  <span>{fmd.installment_amount || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Type:</th>
                                <td>
                                  <span>{fmd.liability_type || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Status:</th>
                                <td>
                                  <span>{fmd.account_status || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Security Offered:</th>
                                <td>
                                  <span>{fmd.security_offered || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Institution:</th>
                                <td>
                                  <span>{fmd.institution || "N/A"}</span>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  ))
                ) : (
                  <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                    <h5>No Data Available</h5>
                  </div>
                )}
              </div>
            </Col>
          </div>
        </div>
      )}

      <Modal show={showAddModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            {SubmitButtonApi ? "Update" : "Add"} Liability
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-1 p-md-4 p-lg-4">
          <form>
            <Row className="text-gray">
              <Col lg="4" className="mb-2  ">
                <CustomTextField
                  type="text"
                  name="purpose_of_loan"
                  label="Purpose Of Loan"
                  value={Group.purpose_of_loan}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="overdue"
                  value={Group.overdue}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="current_outstanding"
                  value={Group.current_outstanding}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="installment_amount"
                  value={Group.installment_amount}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="liability_type"
                  value={Group.liability_type}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="account_status"
                  value={Group.account_status}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="security_offered"
                  value={Group.security_offered}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="select"
                  name="institution"
                  value={Group.institution}
                  onChange={onInputChange}
                  className="text-gray"
                  style={{ padding: "7px",borderRadius:"3px" }}
                >
                  <option value="">Select</option>
                  {InstituteList.map((item) => {
                    return (
                      <option value={item.bank_name}>{item.bank_name}</option>
                    );
                  })}
                </CustomTextField>
              </Col>
            </Row>

            <Button
              className={`submit-btn`}
              onClick={(e) => AddFamilytSubmit()}
              disabled={disableButton ? true : false}
              style={{ float: "right" }}
              size="sm"
            >
              Submit &nbsp;
              {disableButton ? <Spinner animation="border" size="sm" /> : ""}
            </Button>
            {showError ? (
              <div style={{ color: "red" }}>
                All The fields are mandatory **
              </div>
            ) : (
              ""
            )}
          </form>
        </Modal.Body>
      </Modal>
    </Card>
  );
};

export default FarmerDetailsLiability;
